import * as types from '../types/cartTypes';

export const ensureCartSessionId = () => ({ type: types.CART_ENSURE_SESSION });
export const openCartDrawer = () => ({ type: types.CART_OPEN_DRAWER });
export const closeCartDrawer = () => ({ type: types.CART_CLOSE_DRAWER });
export const addCartLine = (payload) => ({ type: types.CART_ADD_LINE, payload });
export const removeCartLineAtIndex = (index) => ({
  type: types.CART_REMOVE_LINE_AT_INDEX,
  payload: index,
});
export const setCartLineQtyAtIndex = (payload) => ({
  type: types.CART_SET_LINE_QTY_AT_INDEX,
  payload,
});
export const clearCart = () => ({ type: types.CART_CLEAR });

export const selectCartItems = (state) => state.cart?.items ?? [];
export const selectCartDrawerOpen = (state) => state.cart?.drawerOpen ?? false;
export const selectCartSessionId = (state) => state.cart?.cartSessionId ?? null;
